export default {"src":"/_next/static/image/public/images/ic_question.a57a68028182ca188cb54dd46fcdd66e.svg","height":18,"width":18};